const STYLE = {
  breakpoints: {
    xs: 500,
    sm: 575,
    md: 767,
    lg: 991,
    xlg: 1920,
  },
};

export const MOBILE_SCREEN_TYPE = "mobile";
export const TABLET_SCREEN_TYPE = "tablet";
export const DESKTOP_SCREEN_TYPE = "desktop";
export const LARGE_DISPLAY_SCREEN_TYPE = "largeDisplay";

export const MAX_WIDTH = {
  [MOBILE_SCREEN_TYPE]: "767px",
  [TABLET_SCREEN_TYPE]: "1023px",
  [DESKTOP_SCREEN_TYPE]: "1900px",
};

export const SIZES = [
  MOBILE_SCREEN_TYPE,
  TABLET_SCREEN_TYPE,
  DESKTOP_SCREEN_TYPE,
  LARGE_DISPLAY_SCREEN_TYPE,
];

export const { breakpoints } = STYLE;
export default STYLE;
